import { render, staticRenderFns } from "./DemoBanner.vue?vue&type=template&id=6f7840da&scoped=true"
import script from "./DemoBanner.vue?vue&type=script&lang=js"
export * from "./DemoBanner.vue?vue&type=script&lang=js"
import style0 from "./DemoBanner.vue?vue&type=style&index=0&id=6f7840da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7840da",
  null
  
)

export default component.exports